import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import debounce from 'lodash/debounce';
import defaultTo from 'lodash/defaultTo';
import isNil from 'lodash/isNil';
import { toPx } from '../../../lib/_util/UnitConvertor';
import { DISABLED_FIELD } from '../select/Select';
import { SelectBox } from '../select-box/SelectBox';
import { ViewMode } from '../radio/enum';
import Option from '../option/Option';
import autobind from '../_util/autobind';
function recordIsDisabled(record) {
    return record.get(DISABLED_FIELD) || record.disabled;
}
let Segmented = class Segmented extends SelectBox {
    constructor(props, context) {
        super(props, context);
        this.handleBrowerResize = debounce(() => {
            const { fullWidth } = this.props;
            if (fullWidth) {
                this.forceUpdate();
            }
        }, 50);
        this.initValue();
    }
    get multiple() {
        return false;
    }
    get range() {
        return false;
    }
    get searchable() {
        return false;
    }
    get mode() {
        return ViewMode.button;
    }
    componentDidMount() {
        super.componentDidMount();
        window.addEventListener('resize', this.handleBrowerResize);
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener('resize', this.handleBrowerResize);
    }
    initValue() {
        const value = this.getValue();
        const { filteredOptions, valueField, options, props: { onOption } } = this;
        if (filteredOptions.length > 0 &&
            (isNil(value) || filteredOptions.every(record => record.get(valueField) !== value))) {
            const firstNotDisabled = filteredOptions.find(record => {
                const optionProps = onOption({ dataSet: options, record });
                return !(recordIsDisabled(record) || optionProps.disabled);
            });
            this.setValue((firstNotDisabled || filteredOptions[0]).get(valueField));
        }
    }
    saveActiveNode(node) {
        this.activeRadio = node;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'fullWidth',
        ]);
    }
    getWrapperClassNames(...args) {
        const { prefixCls, props: { vertical, fullWidth } } = this;
        return super.getWrapperClassNames({
            [`${prefixCls}-wrapper-vertical`]: vertical,
            [`${prefixCls}-wrapper-fullwidth`]: fullWidth,
        }, ...args);
    }
    getClassName(...props) {
        const { prefixCls, props: { fullWidth }, } = this;
        return super.getClassName({
            [`${prefixCls}-fullwidth`]: fullWidth,
        }, ...props);
    }
    renderSegmentedActive() {
        const { vertical } = this.props;
        let segActiveStyle = { visibility: 'hidden' };
        if (this.activeRadio) {
            const radioInputDom = this.activeRadio;
            if (radioInputDom && radioInputDom.element && radioInputDom.element.parentElement) {
                const radioDom = radioInputDom.element.parentElement;
                let parentDomPadding = 4;
                if (radioDom.parentElement) {
                    const parentDomStyle = window.getComputedStyle(radioDom.parentElement);
                    const parentDomPaddingLeft = toPx(parentDomStyle.paddingLeft);
                    const parentDomPaddingTop = toPx(parentDomStyle.paddingTop);
                    parentDomPadding = defaultTo(vertical ? parentDomPaddingTop : parentDomPaddingLeft, parentDomPadding);
                }
                segActiveStyle = {
                    ...segActiveStyle,
                    visibility: 'visible',
                    width: radioDom.offsetWidth,
                    height: radioDom.offsetHeight,
                    transform: vertical
                        ? `translate(0px, ${radioDom.offsetTop - parentDomPadding}px)`
                        : `translate(${radioDom.offsetLeft - parentDomPadding}px, 0px)`,
                };
            }
        }
        return (React.createElement("div", { className: `${this.prefixCls}-active-show`, style: segActiveStyle }));
    }
    renderSelectItems(items) {
        const nowItems = (React.createElement(React.Fragment, null,
            this.renderSegmentedActive(),
            items));
        return super.renderSelectItems(nowItems);
    }
    getOptionOtherProps(checked) {
        if (checked) {
            return {
                ...super.getOptionOtherProps(checked),
                ref: this.saveActiveNode,
            };
        }
        return super.getOptionOtherProps(checked);
    }
    isSearchFieldInPopup() {
        return false;
    }
    renderSearcher() {
        return null;
    }
    renderSelectAll() {
        return null;
    }
};
Segmented.displayName = 'Segmented';
Segmented.defaultProps = {
    ...SelectBox.defaultProps,
    suffixCls: 'segmented',
    mode: ViewMode.button,
};
Segmented.Option = Option;
__decorate([
    observable
], Segmented.prototype, "activeRadio", void 0);
__decorate([
    autobind,
    action
], Segmented.prototype, "saveActiveNode", null);
__decorate([
    autobind
], Segmented.prototype, "renderSelectItems", null);
__decorate([
    autobind
], Segmented.prototype, "getOptionOtherProps", null);
Segmented = __decorate([
    observer
], Segmented);
export default Segmented;
